import { CONFIG } from '../../utils/constants';
import request from '../../services/request';
import moment from 'moment-timezone';
export default {
  state: {
    config: null,
  },
  getters: {
    [CONFIG.GET]: (state) => state.config,
    [CONFIG.GET_TENANT_ID]: (state) => state.config.tenantId,
    [CONFIG.GET_NAVIGATION_RULES]: (state, getters) =>
      getters[CONFIG.GET] ? getters[CONFIG.GET].navigationRules || {} : {},
    [CONFIG.GET_SHARED]: (state, getters) => getters[CONFIG.GET].shared || {},
    [CONFIG.GET_SHARED_INTEGRATIONS]: (state, getters) =>
      getters[CONFIG.GET_SHARED].integrations || {},
    [CONFIG.GET_INSTITUTIONAL_SITE_URL]: (state, getters) =>
      getters[CONFIG.GET_SHARED_INTEGRATIONS].INSTITUTIONAL_SITE_URL,
    [CONFIG.GET_EMAIL_ENABLED]: (state, getters) =>
      getters[CONFIG.GET_SHARED].SEND_EMAIL_ENABLED,
    [CONFIG.GET_SMS_ENABLED]: (state, getters) =>
      getters[CONFIG.GET_SHARED].SEND_SMS_ENABLED,
    [CONFIG.GET_JUNIX_BANK_FINANCING_BASE_URL]: (state, getters) =>
      getters[CONFIG.GET_SHARED_INTEGRATIONS].JUNIX_BANK_FINANCING_BASE_URL ||
      '',
    [CONFIG.GET_JUNIX_STATUS_URL]: (state, getters) =>
      getters[CONFIG.GET_SHARED_INTEGRATIONS].JUNIX_STATUS_URL || '',

    [CONFIG.GET_KITFIX_URL]: (state, getters) =>
      getters[CONFIG.GET_SHARED_INTEGRATIONS].KITFIX_URL || '',
    [CONFIG.GET_FINANCIAL_RULE]: (state, getters) =>
      getters[CONFIG.GET_NAVIGATION_RULES].financial || {},
    [CONFIG.GET_SLIP_TIMEOUT_HOURS]: (state, getters) =>
      getters[CONFIG.GET_FINANCIAL_RULE].slipTimeoutHours || 24,
    [CONFIG.GET_SLIP_SOLICITATION_DAYS]: (state, getters) =>
      getters[CONFIG.GET_FINANCIAL_RULE].slipSolicitationDays || 2,
    [CONFIG.GET_TO_EXPIRE_PERIOD_DAYS]: (state, getters) =>
      getters[CONFIG.GET_FINANCIAL_RULE].toExpirePeriodDays || 20,
    [CONFIG.GET_IFRAME]: (state, getters) =>
      getters[CONFIG.GET_NAVIGATION_RULES].iframe || null,
    [CONFIG.GET_COMPLIANCE]: (state, getters) =>
      getters[CONFIG.GET_NAVIGATION_RULES]?.compliance || null,
    [CONFIG.GET_IS_COMPLIANCE_ACTIVE]: (state, getters) =>
      getters[CONFIG.GET_COMPLIANCE]?.isActive || null,
    [CONFIG.GET_IS_COMPLIANCE_ACTIVE_ADMIN]: (state, getters) =>
      getters[CONFIG.GET_COMPLIANCE].isActiveAdmin || null,
    [CONFIG.GET_LOGTRACE_WAIT_MS]: (state, getters) =>
      getters[CONFIG.GET_NAVIGATION_RULES].logTraceWaitMs || -1,
    [CONFIG.GET_POPUPS]: (state, getters) =>
      getters[CONFIG.GET_NAVIGATION_RULES].popups || [],
    [CONFIG.SHOW_BLOCKADE_WARNING]: (state, getters) => {
      const blockadeWarning =
        getters[CONFIG.GET_NAVIGATION_RULES].blockadeWarning || null;
      return (
        blockadeWarning &&
        blockadeWarning.enabled &&
        (!blockadeWarning.period ||
          moment().isBetween(
            blockadeWarning.period.start,
            blockadeWarning.period.end
          ))
      );
    },
  },
  mutations: {
    [CONFIG.SET]: (state, payload) => {
      state.config = payload;
    },
  },
  actions: {},
};



// WEBPACK FOOTER //
// ./src/store/modules/config.js